import { ConversationInsightType } from "@redotech/redo-shopper-agent-common/trigger-definition";
import * as z from "zod";

const labelCount = z.object({
  label: z.string().nullable(),
  count: z.number(),
});
const topicCount = z.object({ topic: z.string(), count: z.number() });
const dayCount = z.object({ date: z.string(), count: z.number() });

export const shopperAgentInsightsAnalytics = {
  name: "shopperAgentInsightsAnalytics" as const,
  input: z.object({
    start: z.date(),
    end: z.date(),
    conversationType: z
      .enum([
        ConversationInsightType.COMMERCE_AGENT,
        ConversationInsightType.MARKETING,
      ])
      .optional(),
  }),
  output: z.object({
    totalConversations: z.number(),
    sentiment: z.array(labelCount),
    topics: z.array(topicCount),
    handledBy: z.array(labelCount),
    timeSeries: z.array(dayCount),
  }),
};
